<template>
  <div class="resumeInformation">
    <div class="table-search">
      <a-form layout="inline">
        <a-row :gutter="12" class="searchRow">
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="出入库类型" v-model="searchModel.name" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColInput">
            <a-input placeholder="仓库名称" v-model="searchModel.number" />
          </a-col>
          <a-col :md="4" :sm="24" class="searchColBtn">
            <span class="table-page-search-submitButtons">
              <a-button class="btn" type="primary" @click="search">查询</a-button>
              <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      class="resumeInformationTable"
      id="resumeInformationTable"
      bordered
      :pagination="pagination"
      :columns="table.columns"
      :rowKey="(record) => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange"
    >
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click.stop="() => handleDetail(record)">详情</a>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  name: 'resumeInformation',
  props: {
    model: Object,
  },
  watch: {
    model: {
      handler(model) {
        if (model) this.initTableData()
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      table: {
        columns: [
          {
            title: '序号',
            dataIndex: 'serial',
          },
          {
            title: '出入库类型',
            dataIndex: 'name',
          },
          {
            title: '入库仓库',
            dataIndex: 'warehouse',
            width: 190,
          },
          {
            title: '入库数量',
            dataIndex: 'number',
            width: 150,
          },
          {
            title: '入库时间',
            dataIndex: 'date',
            width: 150,
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions',
            },
            width: 90,
          },
        ],
        data: [
          {
            id: 0,
            serial: '1',
            name: '采购入库',
            warehouse: '杭氧宏运仓库',
            number: '1',
            date: '2022-12-01 18:00'
          },
          {
            id: 1,
            serial: '2',
            name: '采购入库',
            warehouse: '杭氧宏运仓库',
            number: '2',
            date: '2022-12-01 18:00'
          },
          {
            id: 2,
            serial: '3',
            name: '使用出库',
            warehouse: '杭氧宏运仓库',
            number: '1',
            date: '2022-12-01 18:00'
          },
          {
            id: 3,
            serial: '4',
            name: '使用出库',
            warehouse: '杭氧宏运仓库',
            number: '1',
            date: '2022-12-01 18:00'
          },
          {
            id: 4,
            serial: '5',
            name: '采购入库',
            warehouse: '杭氧宏运仓库',
            number: '1',
            date: '2022-12-01 18:00'
          },
        ],
        loading: false,
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 23,
        showSizeChanger: true,
        showQuickJumper: true,
      },
      searchModel: {},
    }
  },
  methods: {
    initTableData () {},
    handleDetail (record) {},
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    },
    search () {
      const model = { ...this.searchModel }
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.pagination.current = 1
      this.initTableData()
    },
    clearSearch () {
      this.searchModel = {}
      this.pagination.current = 1
      this.initTableData()
    },
  },
}
</script>

<style lang="less" scoped>
.resumeInformation {
  .table-search {
    margin: 10px;
    .searchColBtn {
      .btn {
        margin-right: 10px;
      }
    }
  }
  .resumeInformationTable {
    margin-left: -1px;
    margin-right: -1px;

    /deep/.ant-table{
      .ant-table-thead{
        > tr{
          > th{
            background: rgba(8,64,159,0.1);
          }
        }
      }
      .ant-table-row-expand-icon {
        margin-right: 0;
      }
    }
    /deep/.ant-table-bordered{
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td{
        border-color: #DDDDDD;
      }
      .ant-table-header > table,
      .ant-table-body > table,
      .ant-table-fixed-left table,
      .ant-table-fixed-right table{
        border-color: #DDDDDD;
      }
    }
  }
}
</style>